import React from "react";
import {
  IconSunrise,
  IconSun,
  IconSunset2,
  IconMoon,
} from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { DaytimeSlot } from "@/types/pillbox";
import styles from "./DaytimeMultiSelect.module.css";

export interface DaytimeMultiSelectProps {
  selected: DaytimeSlot[];
  onChange: (selected: DaytimeSlot[]) => void;
}

const SLOTS: Array<{ key: DaytimeSlot; icon: React.ReactNode }> = [
  { key: "morning", icon: <IconSunrise size={24} stroke={1.5} /> },
  { key: "afternoon", icon: <IconSun size={24} stroke={1.5} /> },
  { key: "evening", icon: <IconSunset2 size={24} stroke={1.5} /> },
  { key: "night", icon: <IconMoon size={24} stroke={1.5} /> },
];

const DaytimeMultiSelect: React.FC<DaytimeMultiSelectProps> = ({
  selected,
  onChange,
}) => {
  const { t } = useTranslation();

  const toggle = (slot: DaytimeSlot) => {
    onChange(
      selected.includes(slot)
        ? selected.filter((s) => s !== slot)
        : [...selected, slot]
    );
  };

  return (
    <div className={styles.row}>
      {SLOTS.map((slot) => {
        const isSelected = selected.includes(slot.key);
        return (
          <button
            type="button"
            key={slot.key}
            className={`${styles.card} ${styles[slot.key]} ${
              isSelected ? styles.selected : ""
            }`}
            onClick={() => toggle(slot.key)}
          >
            {slot.icon}
            <span className={styles.label}>
              {t(`pillbox.daytime.${slot.key}`)}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default DaytimeMultiSelect;
